import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Transaction } from '@root/entities/transaction'

import { TransactionsFilter } from './transactions-filter'

import type { UserTransactionsModel } from '@root/features/user/transaction-history'

type Props = {
  model: UserTransactionsModel
}
export const TransactionsTypeFilter = ({ model }: Props) => {
  const { t } = useTranslation()
  const [typeFilterOpen, setTypeFilterOpen] = useState(false)

  const [typeFilter] = useAtom(model.typeFilter)
  const setTypeFilter = useAction(model.setTypeFilter)

  const options = useMemo(
    () => [
      { label: t('transaction.transactions_all'), value: undefined },
      ...Transaction.txTypes.map((type) => ({
        label: t(`transaction.type_${type}`),
        value: type,
      })),
    ],
    [t],
  )

  return (
    <TransactionsFilter
      options={options}
      value={typeFilter}
      onChange={setTypeFilter}
      open={typeFilterOpen}
      onOpenChange={setTypeFilterOpen}
    />
  )
}
